import { connect } from 'react-redux';

import AddHazardControlDialog from '../../components/AddHazardControlDialog';
import {
  openAddHazardControlDialogDispatch,
  handleHazardInputChangeDispatch,
  submitControlDispatch,
  removeHazardControlAttachment,
  openDocumentListDialogDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    openDialog: state.hazard.newControl.openAddHazardControlDialog,
    isSaving: state.hazard.newControl.isSaving,
    control: state.hazard.newControl.item,
    hazard: state.hazard.newHazard.item,
    branchId: state.branch.branch.item && state.branch.branch.item.id,
    allAttachments: state.hazard.newControl.item.attachmentFiles,
    loggedInUser: state.users.user.item,
    allAttachments: state.hazard.newControl.item.attachmentFiles

  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onOpenAddHazardControlDialog: (open) => {
      dispatch(openAddHazardControlDialogDispatch(open));
    },
    onHandleInputChange: (value, inputFieldName) => {
      dispatch(handleHazardInputChangeDispatch(value, inputFieldName));
    },
    submitControl: (payload, mode, branchId) => {
      dispatch(submitControlDispatch(payload, mode, branchId));
    },
    onRemoveAttachment: (attachment) => {
      dispatch(removeHazardControlAttachment(attachment));
    },
    openDocumentListDialog: (open) => {
      dispatch(openDocumentListDialogDispatch(open));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddHazardControlDialog);
